export const clamp = (v: number, min: number, max: number) => Math.min(max, Math.max(min, v));

/** part / whole, 0 when there is no whole (progress bars). */
export const ratio = (part: number, whole: number) => (whole ? part / whole : 0);

/** Cubic ease-out for JS animations driven by requestAnimationFrame (matches CSS ease-out closely). */
export const easeOutCubic = (t: number) => 1 - Math.pow(1 - t, 3);

/** Linear interpolation between two [lat, lng] (or any 2D) points. */
export const lerp2 = (a: readonly [number, number], b: readonly [number, number], k: number): [number, number] => [a[0] + (b[0] - a[0]) * k, a[1] + (b[1] - a[1]) * k];
